var _circle, _circle2, _rect, _rect2, _path, _rect3, _rect4, _path2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfpErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 96,
    viewBox: "0 0 281 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102.967,
    cy: 45.9671,
    r: 25.4671,
    stroke: "#2F322D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.7462,
    cy: 69.2935,
    r: 2.14072,
    fill: "#F74164",
    stroke: "#2F322D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 36,
    width: 4.44102,
    height: 23.7765,
    transform: "rotate(45 110 36)",
    fill: "#F74164"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 53,
    width: 4.44102,
    height: 23.7765,
    transform: "rotate(135 113 53)",
    fill: "#F74164"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.235 53.9179L139.553 71.3896L126.763 58.5994L144.235 53.9179Z",
    fill: "#A9FED7",
    stroke: "#2F322D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 171.075,
    y: 44.5764,
    width: 17.5731,
    height: 37.7154,
    transform: "rotate(-45 171.075 44.5764)",
    fill: "#A9FED7",
    stroke: "#2F322D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 145.523,
    y: 50.2998,
    width: 24.3356,
    height: 24.3356,
    transform: "rotate(-29.5809 145.523 50.2998)",
    fill: "#FAE06D",
    stroke: "#2F322D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.271 20.0001L151.725 39.9829L141.607 54.3898L135.844 50.3426L141.915 41.6985L119.224 25.7628L123.271 20.0001Z",
    fill: "#1E7FE1",
    stroke: "#2F322D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 66.5,
    y1: 71.8145,
    x2: 213.5,
    y2: 71.8145,
    stroke: "#2F322D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfpErrorIcon);
export default __webpack_public_path__ + "static/media/rfpErrorIcon.fba63f1271354bc2fdf9009858a36548.svg";
export { ForwardRef as ReactComponent };